export default () => {
    let siteHost = location.hostname;
    siteHost = siteHost.replace(/^test./, '');
    siteHost = siteHost.replace('m.', '').replace('www.', '');
    return siteHost;
};
